var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 15.4252C1.06667 15.5585 0.75 15.5294 0.45 15.3377C0.15 15.146 0 14.8669 0 14.5002V10.0002L8 8.00022L0 6.00022V1.50022C0 1.13355 0.15 0.854382 0.45 0.662715C0.75 0.471049 1.06667 0.441882 1.4 0.575215L16.8 7.07522C17.2167 7.25855 17.425 7.56688 17.425 8.00022C17.425 8.43355 17.2167 8.74188 16.8 8.92522L1.4 15.4252Z",
    fill: "#CC2630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.007caa2128ce44cc7e43115c878e0d91.svg";
export { ForwardRef as ReactComponent };